interface FlagIconProps {
  countryCode: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  title?: string
}

const sizeClasses: Record<NonNullable<FlagIconProps['size']>, string> = {
  sm: 'text-xl',
  md: 'text-3xl',
  lg: 'text-4xl',
  xl: 'text-5xl'
}

function FlagIcon({
  countryCode,
  size = 'md',
  className = '',
  title
}: FlagIconProps) {
  const normalizedCode = countryCode.toLowerCase()
  const sizeClass = sizeClasses[size] ?? sizeClasses.md

  return (
    <span
      className={`fi fi-${normalizedCode} ${sizeClass} ${className}`.trim()}
      style={{ 
        width: '1.33em', 
        lineHeight: '1em',
        boxShadow: 'inset 0 0 0 1px rgba(0, 0, 0, 0.1)' 
      }}
      aria-label={title || countryCode}
      role="img"
    />
  )
}

export default FlagIcon
